function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("desc", null, "Created with Fabric.js 1.7.22");

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    version: 1.1,
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve"
  }, props), _ref, _ref2, React.createElement("g", {
    transform: "translate(128 128) scale(0.72 0.72)",
    style: {}
  }, React.createElement("g", {
    style: {
      "stroke": "none",
      "strokeWidth": 0,
      "strokeDasharray": "none",
      "strokeLinecap": "butt",
      "strokeLinejoin": "miter",
      "strokeMiterlimit": 10,
      "fill": "none",
      "fillRule": "nonzero",
      "opacity": 1
    },
    transform: "translate(-175.05 -175.05000000000004) scale(3.89 3.89)"
  }, React.createElement("path", {
    d: "M 77.474 17.28 L 61.526 1.332 C 60.668 0.473 59.525 0 58.311 0 H 15.742 c -2.508 0 -4.548 2.04 -4.548 4.548 v 80.904 c 0 2.508 2.04 4.548 4.548 4.548 h 58.516 c 2.508 0 4.549 -2.04 4.549 -4.548 V 20.496 C 78.807 19.281 78.333 18.138 77.474 17.28 z M 61.073 5.121 l 12.611 12.612 H 62.35 c -0.704 0 -1.276 -0.573 -1.276 -1.277 V 5.121 z M 15.742 3 h 42.332 v 13.456 c 0 2.358 1.918 4.277 4.276 4.277 h 13.457 v 33.2 H 14.194 V 4.548 C 14.194 3.694 14.888 3 15.742 3 z M 74.258 87 H 15.742 c -0.854 0 -1.548 -0.694 -1.548 -1.548 V 56.934 h 61.613 v 28.519 C 75.807 86.306 75.112 87 74.258 87 z",
    style: {
      "stroke": "none",
      "strokeWidth": 1,
      "strokeDasharray": "none",
      "strokeLinecap": "butt",
      "strokeLinejoin": "miter",
      "strokeMiterlimit": 10,
      "fill": "rgb(0,0,0)",
      "fillRule": "nonzero",
      "opacity": 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), React.createElement("path", {
    d: "M 33.635 82.312 h -5.947 c -2.391 0 -4.336 -1.945 -4.336 -4.336 v -10.93 c 0 -2.391 1.945 -4.336 4.336 -4.336 h 5.947 c 0.829 0 1.5 0.672 1.5 1.5 s -0.671 1.5 -1.5 1.5 h -5.947 c -0.737 0 -1.336 0.6 -1.336 1.336 v 10.93 c 0 0.736 0.599 1.336 1.336 1.336 h 5.947 c 0.829 0 1.5 0.672 1.5 1.5 S 34.464 82.312 33.635 82.312 z",
    style: {
      "stroke": "none",
      "strokeWidth": 1,
      "strokeDasharray": "none",
      "strokeLinecap": "butt",
      "strokeLinejoin": "miter",
      "strokeMiterlimit": 10,
      "fill": "rgb(0,0,0)",
      "fillRule": "nonzero",
      "opacity": 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), React.createElement("path", {
    d: "M 46.959 82.312 h -6.334 c -0.829 0 -1.5 -0.672 -1.5 -1.5 s 0.671 -1.5 1.5 -1.5 h 6.334 c 0.522 0 0.948 -0.426 0.948 -0.948 v -3.404 c 0 -0.522 -0.426 -0.948 -0.948 -0.948 h -3.885 c -2.177 0 -3.949 -1.771 -3.949 -3.948 v -3.403 c 0 -2.178 1.771 -3.949 3.949 -3.949 h 4.312 c 0.828 0 1.5 0.672 1.5 1.5 s -0.672 1.5 -1.5 1.5 h -4.312 c -0.523 0 -0.949 0.426 -0.949 0.949 v 3.403 c 0 0.522 0.426 0.948 0.949 0.948 h 3.885 c 2.177 0 3.948 1.771 3.948 3.948 v 3.404 C 50.907 80.54 49.136 82.312 46.959 82.312 z",
    style: {
      "stroke": "none",
      "strokeWidth": 1,
      "strokeDasharray": "none",
      "strokeLinecap": "butt",
      "strokeLinejoin": "miter",
      "strokeMiterlimit": 10,
      "fill": "rgb(0,0,0)",
      "fillRule": "nonzero",
      "opacity": 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), React.createElement("path", {
    d: "M 65.63 62.759 c -0.787 -0.269 -1.637 0.152 -1.902 0.938 L 59.486 76.18 l -4.24 -12.484 c -0.267 -0.785 -1.117 -1.206 -1.902 -0.938 c -0.784 0.266 -1.204 1.118 -0.938 1.902 l 5.66 16.664 c 0.005 0.016 0.017 0.027 0.022 0.042 c 0.049 0.131 0.112 0.256 0.195 0.369 c 0.003 0.004 0.005 0.01 0.008 0.014 c 0.081 0.107 0.183 0.199 0.292 0.282 c 0.025 0.019 0.049 0.038 0.076 0.055 c 0.106 0.07 0.218 0.132 0.344 0.175 c 0.004 0.001 0.009 0.001 0.013 0.002 c 0.15 0.05 0.308 0.078 0.469 0.078 s 0.319 -0.028 0.469 -0.078 c 0.004 -0.001 0.009 -0.001 0.013 -0.002 c 0.126 -0.043 0.239 -0.105 0.345 -0.176 c 0.025 -0.017 0.049 -0.035 0.073 -0.053 c 0.11 -0.083 0.212 -0.176 0.294 -0.284 c 0.002 -0.003 0.004 -0.007 0.006 -0.01 c 0.085 -0.114 0.147 -0.24 0.197 -0.373 c 0.006 -0.015 0.017 -0.026 0.022 -0.042 l 5.661 -16.664 C 66.834 63.877 66.414 63.025 65.63 62.759 z",
    style: {
      "stroke": "none",
      "strokeWidth": 1,
      "strokeDasharray": "none",
      "strokeLinecap": "butt",
      "strokeLinejoin": "miter",
      "strokeMiterlimit": 10,
      "fill": "rgb(0,0,0)",
      "fillRule": "nonzero",
      "opacity": 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }))));
};

export default __webpack_public_path__ + "static/media/CsvIcon.1fd3f305.svg";
export { SvgComponent as ReactComponent };